import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { DELETE_SURVEY } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { DeleteSurveyDataActionTypes } from './types';
import api from 'src/utils/api';
import { allListSurveyDelete } from '../allSurvey/actions';

export const loadDeleteSurvey =
  (
    id: number,
  ): ThunkAction<Promise<void>, State, null, DeleteSurveyDataActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: DELETE_SURVEY + REQUEST });
    try {
      const payload = await api.loadDeleteSurvey(id);
      dispatch({ type: DELETE_SURVEY + SUCCESS, payload });
      dispatch(allListSurveyDelete(id));
    } catch (error) {
      dispatch({ type: DELETE_SURVEY + FAILURE, error });
    }
  };

export const deleteSurveyIdle = () => ({
  type: DELETE_SURVEY + IDLE,
});
